export default class WorkerBuilder {
  constructor(worker) {
    const code = worker.toString();
    const blob = new Blob([`(${code})()`]);

    return typeof Worker === 'undefined'
      ? { postMessage(message, transfer) { }, onmessage() {} }
      : new Worker(URL.createObjectURL(blob));
  }
}
